import * as Yup from "yup";

export const milestoneSchema = Yup.object().shape({
  name: Yup.string().required("Milestone name is required"),
  description: Yup.string().nullable(),
  date: Yup.date().required("Date of milestone is required"),
  institution_id: Yup.string().required("Institution is required"),
});
